import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

// Esta es la nueva forma de definir un interceptor: como una función constante.
export const AuthInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    
    // Para injectar servicios, ahora usamos la función inject()
    const authService = inject(AuthService);
    const router = inject(Router);
    const token = localStorage.getItem('token');

    let clonedRequest = req;

    // La lógica interna es la misma: si hay token, se clona la petición y se añade la cabecera.
    if (token) {
        clonedRequest = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    // La lógica para manejar errores también es la misma.
    return next(clonedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 || error.status === 403) {
                console.warn('Token inválido o expirado. Cerrando sesión.');
                authService.logout(); // El servicio de auth se encargará de la redirección
            }
            return throwError(() => error);
        })
    );
};